import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch as useReduxDispatch, useSelector as useReduxSelector } from 'react-redux';

// TODO
export const useDispatch: () => any = useReduxDispatch;
export const useSelector: TypedUseSelectorHook<any> = useReduxSelector;
